module.exports = __webpack_public_path__ + "img/andymethod_thumb.cb646da8.jpg";